import { Directive, ElementRef, HostListener, Input, Self, Optional, ChangeDetectorRef } from '@angular/core';
import { FormGroupDirective, NgControl, NgForm } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
var LyFieldDirective = /** @class */ (function () {
    function LyFieldDirective(elementRef, _ngControl, _parentForm, _parentFormGroup, cd) {
        this.elementRef = elementRef;
        this._ngControl = _ngControl;
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        this.cd = cd;
        this.focusState = new Subject();
        this._disabled = false;
        this._required = false;
    }
    LyFieldDirective.prototype.focus = function (isFocused) {
        this.focusState.next(isFocused);
    };
    LyFieldDirective.prototype._blur = function (isFocused) {
        this.focusState.next(isFocused);
    };
    LyFieldDirective.prototype._noop = function () { };
    Object.defineProperty(LyFieldDirective.prototype, "disabled", {
        get: function () { return this._ngControl ? this._ngControl.disabled : this._disabled; },
        set: function (value) { this._disabled = !!(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyFieldDirective.prototype, "required", {
        get: function () { return this._ngControl ? this._ngControl.invalid : this._required; },
        set: function (value) { this._required = !!(value); },
        enumerable: true,
        configurable: true
    });
    LyFieldDirective.prototype.markForCheck = function () {
        this.cd.markForCheck();
    };
    LyFieldDirective.prototype._parent = function () {
        return this._parentFormGroup || this._parentForm;
    };
    LyFieldDirective.prototype._updateErrorState = function () {
        // const oldState = this.errorState;
        var parent = this._parentFormGroup || this._parentForm;
        // const matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
        var control = this._ngControl ? this._ngControl.control : null;
        // const newState = matcher.isErrorState(control, parent);
        // if (newState !== oldState) {
        //   this.errorState = newState;
        //   this.stateChanges.next();
        // }
    };
    LyFieldDirective.prototype.ngOnChanges = function (changes) {
        // if (!changes['placeholder'].firstChange) {
        //   console.log(JSON.stringify(changes['placeholder']))
        // }
    };
    LyFieldDirective.prototype.ngOnDestroy = function () {
        this.focusState.complete();
    };
    LyFieldDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-input input, ly-textarea textarea'
                },] },
    ];
    /** @nocollapse */
    LyFieldDirective.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: NgControl, decorators: [{ type: Optional }, { type: Self },] },
        { type: NgForm, decorators: [{ type: Optional },] },
        { type: FormGroupDirective, decorators: [{ type: Optional },] },
        { type: ChangeDetectorRef, },
    ]; };
    LyFieldDirective.propDecorators = {
        "type": [{ type: Input },],
        "focus": [{ type: HostListener, args: ['focus', ['true'],] },],
        "_blur": [{ type: HostListener, args: ['blur', ['false'],] },],
        "_noop": [{ type: HostListener, args: ['input',] },],
        "disabled": [{ type: Input },],
        "required": [{ type: Input },],
    };
    return LyFieldDirective;
}());
export { LyFieldDirective };
//# sourceMappingURL=ly-field.directive.js.map